import {HttpClient} from "../../service/httpClient/HttpClient";

export class SettingService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getAlphaValue() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `loans/offers/parameters`
            ).then(resolve).catch(reject)
        })
    }

    updateAlphaParameters(alphaParameters) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `loans/offers/parameters`,
                {
                    multiplyLoanAmount: alphaParameters
                }
            ).then(resolve).catch(reject)
        })
    }

    getLoanKindTable() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `loans/kinds/tables`
            ).then(resolve).catch(reject)
        })
    }

    updateTableHeader(id, minT, maxT) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `loans/kinds/tables/headers/${id}`, {minT, maxT}
            ).then(resolve).catch(reject)
        })
    }
}